// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
  monospace;
}

* {
  box-sizing: border-box;
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Loading animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Focus styles for accessibility */
button:focus-visible,
input:focus-visible,
select:focus-visible {
  outline: 2px solid #7c3aed;
  outline-offset: 2px;
}

/* Smooth transitions */
* {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* ===== ORIGINAL DASHBOARD LAYOUT - RESTORED ===== */

/* Desktop - Default optimized layout exactly as shown in image */
.dashboard-grid {
  display: grid;
  grid-template-columns: 200px 200px 200px 220px 300px;
  grid-template-rows: auto auto auto;
  gap: 14px;
  align-items: start;
  margin-bottom: 16px;
}

/* Large screens - More space */
@media (min-width: 1600px) {
  .dashboard-grid {
    grid-template-columns: 200px 200px 200px 220px 320px !important;
    gap: 16px !important;
  }
}

/* Medium-large screens - Tighter spacing */
@media (max-width: 1500px) {
  .dashboard-grid {
    grid-template-columns: 160px 160px 160px 180px 280px !important;
    gap: 12px !important;
  }
}

/* Medium screens - Stack destinations below */
@media (max-width: 1300px) {
  .dashboard-grid {
    grid-template-columns: 1fr 1fr 1fr 200px !important;
    grid-template-rows: auto auto auto auto !important;
    gap: 14px !important;
  }

  /* Move destinations to bottom row spanning full width */
  .destinations-module {
    grid-column: 1 / 5 !important;
    grid-row: 4 !important;
    max-height: 300px !important;
    min-width: auto !important;
    width: 100% !important;
  }

  /* Make country list 4 columns when stacked horizontally */
  .destinations-module .country-list {
    grid-template-columns: repeat(4, 1fr) !important;
    max-height: 200px !important;
    overflow-y: auto !important;
  }

  /* Adjust other modules for better fit */
  .system-module {
    width: 200px !important;
  }

  .account-module {
    width: 200px !important;
  }
}

/* Small-medium screens - 3 column layout */
@media (max-width: 1100px) {
  .dashboard-grid {
    grid-template-columns: 1fr 1fr 180px !important;
    grid-template-rows: auto auto auto auto auto !important;
    gap: 12px !important;
  }

  /* Metric modules positioning */
  .metric-module:nth-child(1) { grid-column: 1 !important; grid-row: 1 !important; }
  .metric-module:nth-child(2) { grid-column: 2 !important; grid-row: 1 !important; }
  .metric-module:nth-child(3) { grid-column: 1 !important; grid-row: 2 !important; }

  /* System module on the right */
  .system-module {
    grid-column: 3 !important;
    grid-row: 1 / 3 !important;
    width: 180px !important;
  }

  /* Origins module spans 2 columns */
  .origins-module {
    grid-column: 1 / 3 !important;
    grid-row: 3 !important;
  }

  /* Account module on the right */
  .account-module {
    grid-column: 3 !important;
    grid-row: 3 !important;
    width: 180px !important;
  }

  /* Services module spans 2 columns */
  .services-module {
    grid-column: 1 / 3 !important;
    grid-row: 4 !important;
  }

  /* Destinations module spans full width at bottom */
  .destinations-module {
    grid-column: 1 / 4 !important;
    grid-row: 5 !important;
    max-height: 280px !important;
    min-width: auto !important;
    width: 100% !important;
  }

  /* Origins list 2 columns on smaller screens */
  .origins-list {
    grid-template-columns: 1fr 1fr !important;
  }
}

/* Small screens - 2 column layout */
@media (max-width: 900px) {
  .dashboard-grid {
    grid-template-columns: 1fr 1fr !important;
    grid-template-rows: auto auto auto auto auto auto !important;
    gap: 12px !important;
  }

  /* Metric modules */
  .metric-module:nth-child(1) { grid-column: 1 !important; grid-row: 1 !important; }
  .metric-module:nth-child(2) { grid-column: 2 !important; grid-row: 1 !important; }
  .metric-module:nth-child(3) { grid-column: 1 / 3 !important; grid-row: 2 !important; }

  /* Other modules */
  .origins-module { grid-column: 1 / 3 !important; grid-row: 3 !important; }
  .system-module { grid-column: 1 !important; grid-row: 4 !important; width: auto !important; }
  .account-module { grid-column: 2 !important; grid-row: 4 !important; width: auto !important; }
  .services-module { grid-column: 1 / 3 !important; grid-row: 5 !important; }
  .destinations-module {
    grid-column: 1 / 3 !important;
    grid-row: 6 !important;
    min-width: auto !important;
    width: 100% !important;
  }

  /* Origins list 2 columns on mobile */
  .origins-list {
    grid-template-columns: 1fr 1fr !important;
  }

  /* Services grid 2 columns on mobile */
  .services-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

/* Extra small screens - single column */
@media (max-width: 600px) {
  .dashboard-grid {
    grid-template-columns: 1fr !important;
    grid-template-rows: repeat(8, auto) !important;
    gap: 10px !important;
  }

  /* Stack everything in single column */
  .metric-module:nth-child(1) { grid-column: 1 !important; grid-row: 1 !important; }
  .metric-module:nth-child(2) { grid-column: 1 !important; grid-row: 2 !important; }
  .metric-module:nth-child(3) { grid-column: 1 !important; grid-row: 3 !important; }
  .origins-module { grid-column: 1 !important; grid-row: 4 !important; }
  .system-module { grid-column: 1 !important; grid-row: 5 !important; width: auto !important; }
  .account-module { grid-column: 1 !important; grid-row: 6 !important; width: auto !important; }
  .services-module { grid-column: 1 !important; grid-row: 7 !important; }
  .destinations-module {
    grid-column: 1 !important;
    grid-row: 8 !important;
    min-width: auto !important;
    width: 100% !important;
    max-height: 400px !important;
  }

  /* Single column lists */
  .origins-list {
    grid-template-columns: 1fr !important;
  }

  .services-grid {
    grid-template-columns: 1fr !important;
  }

  .country-list {
    grid-template-columns: 1fr !important;
  }

  /* Reduce padding on small screens */
  .dashboard-grid > * {
    padding: 10px !important;
  }
}

/* ===== SCROLLABLE CONTENT STYLES ===== */

/* Destinations module scrollbar */
.destinations-module .country-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(245, 158, 11, 0.5) rgba(255, 255, 255, 0.1);
}

.destinations-module .country-list::-webkit-scrollbar {
  width: 4px;
}

.destinations-module .country-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.destinations-module .country-list::-webkit-scrollbar-thumb {
  background: rgba(245, 158, 11, 0.5);
  border-radius: 2px;
}

.destinations-module .country-list::-webkit-scrollbar-thumb:hover {
  background: rgba(245, 158, 11, 0.7);
}

/* Origins module scrollbar */
.origins-module .origins-list::-webkit-scrollbar {
  width: 3px;
}

.origins-module .origins-list::-webkit-scrollbar-track {
  background: rgba(139, 92, 246, 0.1);
  border-radius: 2px;
}

.origins-module .origins-list::-webkit-scrollbar-thumb {
  background: rgba(139, 92, 246, 0.5);
  border-radius: 2px;
}

/* Services module animations */
.service-status-indicator.online {
  background: #22c55e;
  box-shadow: 0 0 10px rgba(34, 197, 94, 0.5);
}

.service-status-indicator.offline {
  background: #ef4444;
  box-shadow: 0 0 10px rgba(239, 68, 68, 0.5);
}

.service-status-indicator.pending {
  background: #f59e0b;
  animation: pulse 2s infinite;
}

/* ===== HOVER EFFECTS ===== */

/* Module hover effects */
.module:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

/* Button hover effects */
button:hover:not(:disabled) {
  transform: translateY(-1px);
}

/* Card hover effects */
.service-card:hover,
.origin-item:hover,
.country-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-1px);
}

/* ===== UTILITY CLASSES ===== */

/* Text selection */
.selectable-text {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
}

/* No text selection */
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}

/* Loading spinner */
.spin {
  animation: spin 1s linear infinite;
}

/* Fade in animation */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

/* Pulse animation */
.pulse {
  animation: pulse 2s infinite;
}

/* ===== DARK THEME ADJUSTMENTS ===== */
@media (prefers-color-scheme: dark) {
  .search-input,
  .filter-select {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
  }

  .search-input::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
}

/* ===== PRINT STYLES ===== */
@media print {
  .dashboard-grid {
    grid-template-columns: 1fr 1fr !important;
    gap: 10px !important;
  }

  .destinations-module,
  .services-module,
  .origins-module {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;YAEU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;WACS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kDAAkD;AACpD;;AAEA,qDAAqD;;AAErD,iEAAiE;AACjE;EACE,aAAa;EACb,oDAAoD;EACpD,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,+DAA+D;IAC/D,oBAAoB;EACtB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,+DAA+D;IAC/D,oBAAoB;EACtB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,mDAAmD;IACnD,kDAAkD;IAClD,oBAAoB;EACtB;;EAEA,wDAAwD;EACxD;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,0DAA0D;EAC1D;IACE,gDAAgD;IAChD,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,wCAAwC;EACxC;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,+CAA+C;IAC/C,uDAAuD;IACvD,oBAAoB;EACtB;;EAEA,+BAA+B;EAC/B,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;;EAEjF,+BAA+B;EAC/B;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA,mCAAmC;EACnC;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA,gCAAgC;EAChC;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,8CAA8C;EAC9C;IACE,yCAAyC;EAC3C;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,yCAAyC;IACzC,4DAA4D;IAC5D,oBAAoB;EACtB;;EAEA,mBAAmB;EACnB,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,8BAA8B,6BAA6B,EAAE,sBAAsB,EAAE;;EAErF,kBAAkB;EAClB,kBAAkB,6BAA6B,EAAE,sBAAsB,EAAE;EACzE,iBAAiB,yBAAyB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;EAC5F,kBAAkB,yBAAyB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;EAC7F,mBAAmB,6BAA6B,EAAE,sBAAsB,EAAE;EAC1E;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,qCAAqC;EACrC;IACE,yCAAyC;EAC3C;;EAEA,sCAAsC;EACtC;IACE,gDAAgD;EAClD;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,qCAAqC;IACrC,8CAA8C;IAC9C,oBAAoB;EACtB;;EAEA,sCAAsC;EACtC,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,8BAA8B,yBAAyB,EAAE,sBAAsB,EAAE;EACjF,kBAAkB,yBAAyB,EAAE,sBAAsB,EAAE;EACrE,iBAAiB,yBAAyB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;EAC5F,kBAAkB,yBAAyB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;EAC7F,mBAAmB,yBAAyB,EAAE,sBAAsB,EAAE;EACtE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA,wBAAwB;EACxB;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA,oCAAoC;EACpC;IACE,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C;;AAE1C,kCAAkC;AAClC;EACE,qBAAqB;EACrB,iEAAiE;AACnE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,8BAA8B;;AAE9B,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;;;EAGE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,gCAAgC;;AAEhC,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE;;IAEE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,yCAAyC;IACzC,oBAAoB;EACtB;;EAEA;;;IAGE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n  sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n  monospace;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* Custom scrollbar for webkit browsers */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Loading animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Focus styles for accessibility */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible {\n  outline: 2px solid #7c3aed;\n  outline-offset: 2px;\n}\n\n/* Smooth transitions */\n* {\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n/* ===== ORIGINAL DASHBOARD LAYOUT - RESTORED ===== */\n\n/* Desktop - Default optimized layout exactly as shown in image */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: 200px 200px 200px 220px 300px;\n  grid-template-rows: auto auto auto;\n  gap: 14px;\n  align-items: start;\n  margin-bottom: 16px;\n}\n\n/* Large screens - More space */\n@media (min-width: 1600px) {\n  .dashboard-grid {\n    grid-template-columns: 200px 200px 200px 220px 320px !important;\n    gap: 16px !important;\n  }\n}\n\n/* Medium-large screens - Tighter spacing */\n@media (max-width: 1500px) {\n  .dashboard-grid {\n    grid-template-columns: 160px 160px 160px 180px 280px !important;\n    gap: 12px !important;\n  }\n}\n\n/* Medium screens - Stack destinations below */\n@media (max-width: 1300px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr 1fr 1fr 200px !important;\n    grid-template-rows: auto auto auto auto !important;\n    gap: 14px !important;\n  }\n\n  /* Move destinations to bottom row spanning full width */\n  .destinations-module {\n    grid-column: 1 / 5 !important;\n    grid-row: 4 !important;\n    max-height: 300px !important;\n    min-width: auto !important;\n    width: 100% !important;\n  }\n\n  /* Make country list 4 columns when stacked horizontally */\n  .destinations-module .country-list {\n    grid-template-columns: repeat(4, 1fr) !important;\n    max-height: 200px !important;\n    overflow-y: auto !important;\n  }\n\n  /* Adjust other modules for better fit */\n  .system-module {\n    width: 200px !important;\n  }\n\n  .account-module {\n    width: 200px !important;\n  }\n}\n\n/* Small-medium screens - 3 column layout */\n@media (max-width: 1100px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr 1fr 180px !important;\n    grid-template-rows: auto auto auto auto auto !important;\n    gap: 12px !important;\n  }\n\n  /* Metric modules positioning */\n  .metric-module:nth-child(1) { grid-column: 1 !important; grid-row: 1 !important; }\n  .metric-module:nth-child(2) { grid-column: 2 !important; grid-row: 1 !important; }\n  .metric-module:nth-child(3) { grid-column: 1 !important; grid-row: 2 !important; }\n\n  /* System module on the right */\n  .system-module {\n    grid-column: 3 !important;\n    grid-row: 1 / 3 !important;\n    width: 180px !important;\n  }\n\n  /* Origins module spans 2 columns */\n  .origins-module {\n    grid-column: 1 / 3 !important;\n    grid-row: 3 !important;\n  }\n\n  /* Account module on the right */\n  .account-module {\n    grid-column: 3 !important;\n    grid-row: 3 !important;\n    width: 180px !important;\n  }\n\n  /* Services module spans 2 columns */\n  .services-module {\n    grid-column: 1 / 3 !important;\n    grid-row: 4 !important;\n  }\n\n  /* Destinations module spans full width at bottom */\n  .destinations-module {\n    grid-column: 1 / 4 !important;\n    grid-row: 5 !important;\n    max-height: 280px !important;\n    min-width: auto !important;\n    width: 100% !important;\n  }\n\n  /* Origins list 2 columns on smaller screens */\n  .origins-list {\n    grid-template-columns: 1fr 1fr !important;\n  }\n}\n\n/* Small screens - 2 column layout */\n@media (max-width: 900px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr 1fr !important;\n    grid-template-rows: auto auto auto auto auto auto !important;\n    gap: 12px !important;\n  }\n\n  /* Metric modules */\n  .metric-module:nth-child(1) { grid-column: 1 !important; grid-row: 1 !important; }\n  .metric-module:nth-child(2) { grid-column: 2 !important; grid-row: 1 !important; }\n  .metric-module:nth-child(3) { grid-column: 1 / 3 !important; grid-row: 2 !important; }\n\n  /* Other modules */\n  .origins-module { grid-column: 1 / 3 !important; grid-row: 3 !important; }\n  .system-module { grid-column: 1 !important; grid-row: 4 !important; width: auto !important; }\n  .account-module { grid-column: 2 !important; grid-row: 4 !important; width: auto !important; }\n  .services-module { grid-column: 1 / 3 !important; grid-row: 5 !important; }\n  .destinations-module {\n    grid-column: 1 / 3 !important;\n    grid-row: 6 !important;\n    min-width: auto !important;\n    width: 100% !important;\n  }\n\n  /* Origins list 2 columns on mobile */\n  .origins-list {\n    grid-template-columns: 1fr 1fr !important;\n  }\n\n  /* Services grid 2 columns on mobile */\n  .services-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n}\n\n/* Extra small screens - single column */\n@media (max-width: 600px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr !important;\n    grid-template-rows: repeat(8, auto) !important;\n    gap: 10px !important;\n  }\n\n  /* Stack everything in single column */\n  .metric-module:nth-child(1) { grid-column: 1 !important; grid-row: 1 !important; }\n  .metric-module:nth-child(2) { grid-column: 1 !important; grid-row: 2 !important; }\n  .metric-module:nth-child(3) { grid-column: 1 !important; grid-row: 3 !important; }\n  .origins-module { grid-column: 1 !important; grid-row: 4 !important; }\n  .system-module { grid-column: 1 !important; grid-row: 5 !important; width: auto !important; }\n  .account-module { grid-column: 1 !important; grid-row: 6 !important; width: auto !important; }\n  .services-module { grid-column: 1 !important; grid-row: 7 !important; }\n  .destinations-module {\n    grid-column: 1 !important;\n    grid-row: 8 !important;\n    min-width: auto !important;\n    width: 100% !important;\n    max-height: 400px !important;\n  }\n\n  /* Single column lists */\n  .origins-list {\n    grid-template-columns: 1fr !important;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .country-list {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Reduce padding on small screens */\n  .dashboard-grid > * {\n    padding: 10px !important;\n  }\n}\n\n/* ===== SCROLLABLE CONTENT STYLES ===== */\n\n/* Destinations module scrollbar */\n.destinations-module .country-list {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(245, 158, 11, 0.5) rgba(255, 255, 255, 0.1);\n}\n\n.destinations-module .country-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.destinations-module .country-list::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n.destinations-module .country-list::-webkit-scrollbar-thumb {\n  background: rgba(245, 158, 11, 0.5);\n  border-radius: 2px;\n}\n\n.destinations-module .country-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(245, 158, 11, 0.7);\n}\n\n/* Origins module scrollbar */\n.origins-module .origins-list::-webkit-scrollbar {\n  width: 3px;\n}\n\n.origins-module .origins-list::-webkit-scrollbar-track {\n  background: rgba(139, 92, 246, 0.1);\n  border-radius: 2px;\n}\n\n.origins-module .origins-list::-webkit-scrollbar-thumb {\n  background: rgba(139, 92, 246, 0.5);\n  border-radius: 2px;\n}\n\n/* Services module animations */\n.service-status-indicator.online {\n  background: #22c55e;\n  box-shadow: 0 0 10px rgba(34, 197, 94, 0.5);\n}\n\n.service-status-indicator.offline {\n  background: #ef4444;\n  box-shadow: 0 0 10px rgba(239, 68, 68, 0.5);\n}\n\n.service-status-indicator.pending {\n  background: #f59e0b;\n  animation: pulse 2s infinite;\n}\n\n/* ===== HOVER EFFECTS ===== */\n\n/* Module hover effects */\n.module:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n}\n\n/* Button hover effects */\nbutton:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n/* Card hover effects */\n.service-card:hover,\n.origin-item:hover,\n.country-item:hover {\n  background: rgba(255, 255, 255, 0.1) !important;\n  transform: translateY(-1px);\n}\n\n/* ===== UTILITY CLASSES ===== */\n\n/* Text selection */\n.selectable-text {\n  user-select: text;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n}\n\n/* No text selection */\n.no-select {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n}\n\n/* Loading spinner */\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Fade in animation */\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n/* Pulse animation */\n.pulse {\n  animation: pulse 2s infinite;\n}\n\n/* ===== DARK THEME ADJUSTMENTS ===== */\n@media (prefers-color-scheme: dark) {\n  .search-input,\n  .filter-select {\n    background: rgba(255, 255, 255, 0.15);\n    color: #fff;\n  }\n\n  .search-input::placeholder {\n    color: rgba(255, 255, 255, 0.7);\n  }\n}\n\n/* ===== PRINT STYLES ===== */\n@media print {\n  .dashboard-grid {\n    grid-template-columns: 1fr 1fr !important;\n    gap: 10px !important;\n  }\n\n  .destinations-module,\n  .services-module,\n  .origins-module {\n    break-inside: avoid;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
